import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import Spinner from '../../../../components/spinner/Spinner';
import GradeYearHeader from '../common/GradeYearHeader';
import { getUrlParams } from '../../../../utils/shared/urlUtils';

const TrcSummary = props => {
    const {
        location,
        selectedGradeYear,
        isGradeYearsFetching,
        selectGradeYear,
        TrcContent,
        ProbeDetailsPageContainer,
    } = props;
    const { resultId } = getUrlParams(location);
    return isEmpty(selectedGradeYear) || isGradeYearsFetching ? (
        <Spinner />
    ) : (
        <>
            <GradeYearHeader {...props} selectGradeYear={selectGradeYear} />
            {resultId && <ProbeDetailsPageContainer resultId={resultId} />}
            <TrcContent {...props} />
        </>
    );
};

TrcSummary.defaultProps = {
    location: {},
    selectedGradeYear: {},
    isGradeYearsFetching: false,
    selectGradeYear: () => {},
    TrcContent: () => <></>,
    ProbeDetailsPageContainer: () => {},
};

TrcSummary.propTypes = {
    location: PropTypes.object,
    selectedGradeYear: PropTypes.object,
    isGradeYearsFetching: PropTypes.bool,
    selectGradeYear: PropTypes.func,
    TrcContent: PropTypes.func,
    ProbeDetailsPageContainer: PropTypes.func,
};

export default TrcSummary;
